import { useAsyncFn } from 'react-use';

import { useAuth } from '@dotfile/frontend/shared/common';
import { clientPortalRoutes } from '@dotfile/shared/domain';

import { useMaybeFormDatastoreApi } from '../../modules/forms/shared';
import { FormDatastoreState } from '../../modules/forms/shared/context/datastore/datastore';
import { useRouter } from '../../routes';

export const useLogout = () => {
  const { logout } = useAuth();

  // useMaybe because this component could be rendered where there is not FormDataStore provider
  const maybeFormDatastoreApi = useMaybeFormDatastoreApi();

  const router = useRouter();

  const [{ loading }, logoutFn] = useAsyncFn(
    async (options?: {
      to?: keyof typeof clientPortalRoutes;
      afterLogout?: (formState: FormDatastoreState) => void;
    }) => {
      await logout();
      if (maybeFormDatastoreApi) {
        // Must reset the whole store otherwise it will detect that a form in in progress (from the progress.currentStepKey)
        maybeFormDatastoreApi.getState().reset();
      }

      const state = maybeFormDatastoreApi?.getState();
      if (state) {
        options?.afterLogout?.(state);
      }

      // Force redirect to Login after logout
      // In a timeout to wait for the ValidateRouteGuard to have re-rendered with the up to date auth / formInProgress sate
      setTimeout(() => {
        router.push(options?.to || 'Login');
      }, 50);
    },
    [logout, maybeFormDatastoreApi],
  );

  return [logoutFn, { loading }] as const;
};
